<template>
    <div>
        <div class="component">
            <h2>
                <router-link :to="component.name.toLowerCase()">{{component.name}}</router-link>
                <br />
                <small>{{component.description}}</small>
            </h2>

            <div class="incidents" v-for="incident in visibleIncidents" v-bind:key="incident.id">
                <div class="incident">
                    <h4 class="title">
                        <icon
                            name="info"
                            class="text-info icon"
                            title="Component is up."
                            v-if="incident.componentDown"
                        ></icon>
                        <icon
                            name="exclamation-triangle"
                            class="text-danger icon"
                            title="Component is down."
                            v-else
                        ></icon>
                        <router-link :to="`/incidents/${incident.id}`">
                            <span
                                class="icon-label icon-label__default"
                            >{{ getIncidentStartDate(incident) | date }}</span>
                        </router-link>

                        <div class="pull-right" v-if="isAuthenticated">
                            <span class="edit">
                                <router-link :to="`/incidents/${incident.id}/edit`">
                                    <icon name="edit" class="icon" title="Edit"></icon>
                                    <small class="icon-label">Edit</small>
                                </router-link>
                            </span>
                            <span class="delete" @click.prevent="confirmDelete(incident.id)">
                                <icon name="remove" class="icon" title="Delete"></icon>
                                <small class="icon-label">Delete</small>
                            </span>
                        </div>
                    </h4>
                    <blockquote
                        class="blockquote"
                        v-for="message in incident.messages"
                        v-bind:key="message.id"
                    >
                        <p
                            class="mb-0"
                            v-for="line in message.body.split(/\r?\n/)"
                            v-bind:key="line"
                        >
                            {{ line }}<br/>
                        </p>
                        <footer
                            class="blockquote-footer"
                        >Posted on {{message.postedAt | date }} at {{message.postedAt | time }} UTC</footer>
                    </blockquote>
                </div>
            </div>
            <nav class="pagination-section" v-if="isPaginationVisible">
                <ul class="pagination">
                    <li class="page-item" :class="{ disabled: pagination.currentPage == 0}">
                        <a class="page-link" @click.prevent="previousPage()">Previous</a>
                    </li>
                    <li
                        class="page-item"
                        v-for="page in pagination.numOfPage"
                        v-bind:key="page"
                        :class="{ active: page == (pagination.currentPage + 1) }"
                    >
                        <a class="page-link" @click.prevent="selectPage(page)">{{page}}</a>
                    </li>
                    <li
                        class="page-item"
                        :class="{ disabled: pagination.currentPage == (pagination.numOfPage - 1) }"
                    >
                        <a class="page-link" @click.prevent="nextPage()">Next</a>
                    </li>
                </ul>
            </nav>
        </div>
        <confirm-dialog
            :is-visible="isDeleteDialogVisible"
            :message="dialogMessage"
            dialog-action="Delete"
            v-on:close="onCofirmDialog"
        ></confirm-dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import ConfirmDialog from "./ConfirmDialog.vue"
import { NotificationsMixin } from "./mixin"
import store from "../store"

export default {
    name: "List",
    mixins: [NotificationsMixin],
    components: {
        confirmDialog: ConfirmDialog
    },
    data() {
        return {
            visibleIncidents: [],
            perPage: 20,
            isPaginationVisible: false,
            pagination: null,
            isDeleteDialogVisible: false,
            dialogMessage:
                "Deleting incident will also remove all related messages!",
            deleteIncidentId: null
        }
    },
    computed: {
        ...mapGetters({
            isAuthenticated: "isAuthenticated",
            incidents: "getIncidents",
            component: "getComponent"
        })
    },
    mounted() {
        this.loadPagination()
    },
    methods: {
        ...mapActions({
            deleteIncident: "deleteIncident",
            loadIncidents: "loadIncidents"
        }),
        loadPagination() {
            this.isPaginationVisible = this.incidents.length > this.perPage
            this.pagination = {
                count: this.incidents.length,
                currentPage: 0,
                numOfPage: Math.ceil(this.incidents.length / this.perPage)
            }
            this.filterRecords()
        },
        filterRecords() {
            let from = this.perPage * this.pagination.currentPage
            let to = this.perPage * (this.pagination.currentPage + 1) - 1
            this.visibleIncidents = this.incidents.slice(from, to)
            window.scroll({ top: 0, left: 0, behavior: "auto" })
        },
        selectPage(page) {
            this.pagination.currentPage = page - 1
            this.filterRecords()
        },
        nextPage() {
            if (this.pagination.currentPage !== this.pagination.numOfPage - 1) {
                this.pagination.currentPage += 1
                this.filterRecords()
            }
        },
        previousPage(page) {
            if (this.pagination.currentPage !== 0) {
                this.pagination.currentPage -= 1
                this.filterRecords()
            }
        },
        confirmDelete(incidentId) {
            this.deleteIncidentId = incidentId
            this.isDeleteDialogVisible = !this.isDeleteDialogVisible
        },
        onCofirmDialog(isConfirmed) {
            this.isDeleteDialogVisible = !this.isDeleteDialogVisible
            if (isConfirmed) {
                this.deleteIncident(this.deleteIncidentId).then(
                    response => {
                        this.showSuccessMsg({
                            title: "Success.",
                            message: response
                        })
                        this.loadIncidents()
                    },
                    error => {
                        this.showErrorMsg({
                            title: "Error deleting incident!",
                            message: error
                        })
                    }
                )
            }

            this.deleteIncidentId = null
        },
        getIncidentStartDate(incident) {
            if (incident.startDate) {
                return incident.startDate
            } else {
                return incident.messages[0].postedAt
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        store.dispatch("loadIncidents", to.params.component).then(res => next())
    }
}
</script>

<style scoped>
.title {
    padding-bottom: 9px;
    margin: 0 0 10px;
    border-bottom: 1px solid #ccc;
}
.icon {
    text-align: center;
}
.pagination-section {
    text-align: center;
}
.incidents {
    padding-top: 20px;
}

a:hover {
    text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/List.vue